import React from 'react';
import * as VisibilitySensor from 'react-visibility-sensor';
import { Pagination } from '@gin-betting/match-list';

interface NeededProps {
    visibilityChange: Pagination.ReturnedPaginationProps['handleVisibilityChange'];
    page: number;
    visibilityInitRef: Pagination.ReturnedPaginationProps['visibilityInitRef'];
}

export const CustomVisibilitySensor: React.SFC<Partial<NeededProps>> = ({
    visibilityChange = () => null,
    page = 0,
    visibilityInitRef = () => null,
}) => {
    return (
        <VisibilitySensor
            onChange={visibilityChange.bind(null, page)}
            // partialVisibility="bottom"
        >
            {() => (
                <div
                    ref={visibilityInitRef.bind(null, page)}
                    style={
                        __DEV__
                            ? {
                                  background: 'red',
                                  height: '2px',
                                  width: '100%',
                              }
                            : {}
                    }
                />
            )}
        </VisibilitySensor>
    );
};
